"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setVerticalSplitterPosition = void 0;
const getActiveWorkspace_1 = require("../utilities/getActiveWorkspace");
function setVerticalSplitterPosition(draft, action) {
    const currentWorkspacePreferences = (0, getActiveWorkspace_1.getActiveWorkspace)(draft);
    currentWorkspacePreferences.general.verticalSplitterPosition =
        action.payload.value;
}
exports.setVerticalSplitterPosition = setVerticalSplitterPosition;
